import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".RetryPaymentPaypal-module_retryPaypalPayment__bG8Y3 {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.RetryPaymentPaypal-module_retryPaypalPaymentButtonContainer__k65nn {\n  width: 100%;\n  margin-top: 16px;\n}\n@media (min-width: 544px) {\n  .RetryPaymentPaypal-module_retryPaypalPaymentButtonContainer__k65nn {\n    width: 180px;\n  }\n}";
var styles = {"retryPaypalPayment":"RetryPaymentPaypal-module_retryPaypalPayment__bG8Y3","retryPaypalPaymentButtonContainer":"RetryPaymentPaypal-module_retryPaypalPaymentButtonContainer__k65nn"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=RetryPaymentPaypal.module.scss.js.map
